import { Dayjs } from 'dayjs';
import Status from './Status';
import { Attachment } from './Attachment';
import { SaleOrder } from './SaleOrder';
import InventoryDocument from './InventoryDocument';
//  {
//                 "id": "138ef622-cc45-435e-b12a-078e2cd30623",
//                 "refTable": "SaleOrders",
//                 "refId": "f919cfb6-931f-4713-b538-dd4c96b03f8a",
//                 "debtAmount": "250000.00",
//                 "code": "CN072500012",
//                 "debtType": "CUSTOMER",
//                 "statusId": "c067a921-ccbf-4d54-a45e-bce5dd6f5c49",
//                 "companyName": "Đậu Huy trung",
//                 "name": "Đậu Huy trung",
//                 "phoneNumber": "0123123123",
//                 "email": "tt@gmail.com",
//                 "address": "",
//                 "deadline": null,
//                 "vat": 0,
//                 "createdAt": "2025-07-15T06:29:51.044Z",
//                 "updatedAt": "2025-07-15T06:29:51.044Z",
//                 "deletedAt": null,
//                 "paidAmount": 0,
//                 "remainingAmount": 250000,
//                 "extraAmount": 0
//             }

export enum ECashFlow {
  INCOME = 'INCOME',
  OUTCOME = 'USD',
}

export interface Debt {
  id: string;
  refTable: 'InventoryDocuments' | 'SaleOrders';
  refId: string;
  code: string;
  debtType: 'CUSTOMER' | 'SUPPLIER';
  debtAmount: number;
  debOwnerId: string;
  statusId: string;
  status: Status;
  companyName: string;
  name: string;
  phoneNumber: string;
  email: string;
  address: string;
  deadline: string;
  vat: number;
  taxCode: string;
  totalAmount: number;
  paidAmount: number;
  remainingAmount: number;
  extraAmount: number;
  cashFlow?: ECashFlow;
  warehouseId?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  debtDueExtensions?: DebtDueExtension[];
  debtAttachments?: DebtAttachment[];
  SaleOrders: SaleOrder[];
  InventoryDocuments: InventoryDocument[];
}
export interface DebtAttachment {
  id?: string;
  debtId?: string;
  attachmentId: string;
  attachment?: Attachment;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date | null;
}
export enum DebtStatusCode {
  WAITING = 'debt-pending', // PENDING - can be Customer or Supplier - rely on cashFlow, debtType, refTable
  COMPLETED = 'debt-completed',
  REFUND = 'debt-refund',
  CONFIRMING = 'debt-confirming',

  // VIRTUAL, don't exist in DB
  OVERDUE = 'overdue',
  OVERDUE_INCOME = 'overdue-income',
  OVERDUE_OUTCOME = 'overdue-outcome',
  CANCELLED = 'cancelled',
  WAITING_INCOME = 'waiting-income',
  WAITING_OUTCOME = 'waiting-outcome',
}
export interface DebtFilter {
  priceRange?: [number, number] | null;
  createdAt?: Dayjs;
  phoneNumber?: string;
  refTable?: string;
  status?: string | DebtStatusCode;
  debtType?: 'CUSTOMER' | 'SUPPLIER';
  codeSearch?: string;
  deadline?: Dayjs;
}

export interface DebtUpdateRequest {
  debtAttachments?: {
    attachmentId: string;
    description?: string;
  }[];
  transaction?: {
    transactionMethodId?: string;
    transactionAmount: number;
    transactionAttachments?: {
      attachmentId: string;
      description?: string;
    }[];
  };
  debtDueExtension?: Omit<DebtDueExtension, 'id' | 'debtId'>;
  statusId?: string;
}
export interface DebtDueExtension {
  id: string;
  debtId: string;
  extraFee: number;
  oldDeadline: string;
  newDeadline: string;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
}
